import cn from 'classnames';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

// TYPES;
import { DOM_ID } from '@UILayer/UILayer.types';

// CSS
import styles from '@UILayer/UILayer.scss';

// IMAGES
import { EConfigurationNames } from '@ConfigLoader/ConfigFiles';
import ConfigLoader from '@ConfigLoader/ConfigLoader';
import { EButtonEvents } from '@Managers/Events/ButtonEvents';
import EventsCenter from '@Managers/Events/EventsCenter';
import { getDeviceInfo, getFullScreen } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';
import { Button } from '@UILayer/Inputs/Button';
import iconIn from './icon_fullscreen_in.svg';
import iconOut from './icon_fullscreen_out.svg';

const FullscreenButton: React.FC<{}> = () => {
    const [state, setState] = useReducer((state: { active: boolean; show: boolean }, newState: any) => ({ ...state, ...newState }), {
        active: true,
        show: true
    });
    const { t } = useTranslation();
    const btnCN = cn(styles.square_btn, styles.standard_btn, styles.fullscreen_btn, state.active ? styles.true : styles.false);
    const device = useAppSelector(getDeviceInfo);
    const gameStoreFullscreen = useAppSelector(getFullScreen);

    useEffect(() => {
        if (device.isiOS) {
            setState({ show: false });
        } else {
            setState({ show: ConfigLoader.getConfiguration(EConfigurationNames.UI_LAYER).buttons.fullScreen });
        }
    }, [device]);

    useEffect(() => {
        setState({ active: gameStoreFullscreen });
    }, [gameStoreFullscreen]);

    function buttonAction() {
        EventsCenter.emit(EButtonEvents.FULLSCREEN_BUTTON_PRESSED);
    }

    return (
        <>
            {state.show && (
                <Button
                    id={DOM_ID.BUTTON_FULLSCREEN}
                    description={`${t('WCA_TOGGLE_FULLSCREEN_MODE_BUTTON')}: ${state.active ? t('WCA_ACTIVE') : t('WCA_IN_ACTIVE')} `}
                    className={btnCN}
                    onChange={buttonAction}
                >
                    <img src={state.active ? iconOut : iconIn} alt={t('WCA_TOGGLE_FULLSCREEN_MODE_BUTTON')} />
                </Button>
            )}
        </>
    );
};

export default FullscreenButton;
